import {useEffect, useState} from "react";

import styled from "styled-components";
import PopupMain from "../components/popup_main";
import MarkdownField from "../components/markdown_field";
import useFeedback from "../utils/use_feedback";
import TextField from "../components/text_field";
import {useSaveClicked} from "../store";
import {useModMessage} from "../api/moderation";
import {themecolors} from "../utils/themecolors";
import TopBar from "../components/top_bar";

const CreateModMessage = styled(({className, community, post, comment, onClose}) => {
    const [subject, setSubject] = useState('');
    const [content, setContent] = useState('');
    const creating = useFeedback(true);
    const createMessage = useModMessage(creating.channel);
    const save = async () => {
        const {author, community} = post ? post : comment;
        try {
            await createMessage(author, community, subject, content);
            onClose();
        } catch {
            // error is displayed
        }
    };
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    await save();
                    setSaving(false);
                }
            }
        })().then(() => {}, () => {});
    }, [saveClicked]);
    return (
        <>
            <TopBar back save border={false} title={'Send a Mod Message'} transparentBackground={false}/>
            <PopupMain className={className}>
                <TextField id='subject' placeholder={'Title'} value={subject} onChange={setSubject} style={{fontSize: 20,
                fontWeight: 600}} />
                <MarkdownField
                    id='content' placeholder="Type your message..." minRows={5}
                    value={content} onChange={setContent}
                />
            </PopupMain>
        </>
    );
})`
  textarea, input {
    border: none;
    outline: none;
    background-color: transparent;
  }
  input::placeholder {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_medium_impact_text};
  }
  input {
    font-size: 16px;
    padding: 12px 24px;
  }
  ${TextField} {
    margin-bottom: 0;
  }
  ${MarkdownField} textarea {
    border: none;
    min-height: 100%;
    outline: none;
  }
  ${MarkdownField} {
    height: 100%;
    margin-bottom: 0;
  }`;

export default CreateModMessage;
